import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NbDialogRef, NbGlobalPhysicalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { take } from 'rxjs';
import { GameService, LanguageService, MissionService, ObjectService, TemplateService } from '../../_services';
import { trigger, transition, animate, style } from '@angular/animations';


@Component({
    selector: 'edit-mission-references',
    templateUrl: './edit-mission-references.component.html',
    styleUrls: ['./edit-mission-references.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('100ms', style({ opacity: 0 })),
            ])
        ])
    ],
    standalone: false
})

export class EditMissionReferencesComponent {
  positions = NbGlobalPhysicalPosition;
  id
  template
  templateMissions
  diffTemplateGame = []
  @Input() templateId;
  gameVisibly = [];
  _missions = [];
  templateObjects
  gameObjects = [];
  neededParams = [
    {label:'successMissions', checked: true},
    {label:'failMissions',    checked: true},
    {label:'successObjects',  checked: true},
    {label:'activateMissions',checked: true},
    {label:'activateObjects', checked: true},
    {label:'neededObjects',   checked: true}
  ]

  constructor(protected ref: NbDialogRef<EditMissionReferencesComponent>,
    public templateService: TemplateService,
    private route: ActivatedRoute,
    public gameService: GameService,
    public objectService: ObjectService,
    public missionService: MissionService,
    private toastrService: NbToastrService,
    public languageService:LanguageService) {
  }
  toggle(index){
    console.log('index',index)
    this.neededParams[index].checked = !this.neededParams[index].checked
  }
  ngOnInit() {
    if(this.templateId){
      this.objectService.listObjects(`game_templates/${this.templateId}/objects`)
      .subscribe(objects => {
        if(objects){
          this.templateObjects = objects
        } 
      });
      this.missionService.listMissions(`game_templates/${this.templateId}/missions`)
      .pipe(take(1))
      .subscribe(async missions => {
        if(missions){
          this.templateMissions = missions
          this.gameService.listTemplateGames(this.templateId)
          .pipe(take(1))
          .subscribe(async games => {
            for(let i = 0; i < games.length; i++) {
              this.objectService.listObjects(`games/${games[i].id}/objects`)
              .pipe(take(1))
              .subscribe(objects => {
                if(objects){
                  this.gameObjects[games[i].id] = objects
                }
              });
              this.missionService.listMissions(`games/${games[i].id}/missions`)
              .pipe(take(1))
              .subscribe(async missions => {
                this._missions[games[i].id] = missions
                if(missions){
                  //  successMissions[] / successObjects[] / failMissions[] / optionalDependencies{} /  dependencies{}
                  //  forkSelections => activateMissions /  activateObjects / neededObjects
                  for(let templateMission of this.templateMissions){
                    let mission = missions.find(mission => mission.id == templateMission.id)
                    if(mission){
                      let forkActivateMissions = {template : [],game: []}
                      let forkActivateObjects = {template : [],game: []}
                      let forkNeededObjects = {template : [],game: []}
                      let result = {activateMissions: false, activateObjects: false, neededObjects: false}
                      for(let templateForkSelection of templateMission.forkSelections){
                        let activateMissions = this.getDiffOnForkSelections(mission.forkSelections, templateForkSelection, 'activateMissions')
                        let activateObjects = this.getDiffOnForkSelections(mission.forkSelections, templateForkSelection, 'activateObjects')
                        let neededObjects = this.getDiffOnForkSelections(mission.forkSelections, templateForkSelection, 'neededObjects')
                        if(!activateMissions) {
                          forkActivateMissions.template.push(templateMission.forkSelections)
                          forkActivateMissions.game.push(mission.forkSelections)
                          result.activateMissions = true
                        }
                        if(!activateObjects) {
                          forkActivateObjects.template.push(templateMission.forkSelections)
                          forkActivateObjects.game.push(mission.forkSelections)
                          result.activateObjects = true
                        }
                        if(!neededObjects) {
                          forkNeededObjects.template.push(templateMission.forkSelections)
                          forkNeededObjects.game.push(mission.forkSelections)
                          result.neededObjects = true
                        }
                      }
                      let successMissions   = this.getDifference(mission.successMissions, templateMission.successMissions, '')
                      let failMissions = this.getDifference(mission.failMissions, templateMission.failMissions, '')
                      let successObjects = this.getDifference(mission.successObjects, templateMission.successObjects, '')
                      let dependencies = this.getDifference(mission.dependencies, templateMission.dependencies, 'dependencies')
                      let optionalDependencies = this.getDifference(mission.optionalDependencies, templateMission.optionalDependencies, 'dependencies')
                      
                      if(result.neededObjects || result.activateObjects || result.activateMissions || !successMissions || !failMissions || !successObjects || !dependencies || !optionalDependencies){
                        let data = {
                          template: {
                            missionId         : templateMission.id,
                            templateId        : this.templateId,
                            missionName       : templateMission.name[this.languageService.currentLang],
                            successMissions   : successMissions? [] : templateMission.successMissions,
                            failMissions      : failMissions? [] : templateMission.failMissions,
                            successObjects    : successObjects? [] : templateMission.successObjects,
                            activateMissions  : !result.activateMissions ? [] : forkActivateMissions.template,
                            activateObjects   : !result.activateObjects ? [] : forkActivateObjects.template,
                            neededObjects     : !result.neededObjects ? [] : forkNeededObjects.template,
                            dependencies      : dependencies?  [] : templateMission.dependencies,
                            optionalDependencies : optionalDependencies? [] : templateMission.optionalDependencies,
                          }, game: {
                            missionId         : mission.id,
                            gameId            : games[i].id,
                            missionName       : mission.name[this.languageService.currentLang],
                            successMissions   : successMissions ? [] : mission.successMissions,
                            failMissions      : failMissions? [] : mission.failMissions,
                            successObjects    : successObjects? [] : mission.successObjects,
                            activateMissions  : !result.activateMissions ? [] : forkActivateMissions.game,
                            activateObjects   : !result.activateObjects ? [] : forkActivateObjects.game,
                            neededObjects     : !result.neededObjects ? [] : forkNeededObjects.game,
                            dependencies      : dependencies?  [] : mission.dependencies,
                            optionalDependencies : optionalDependencies? [] : mission.optionalDependencies,
                          }
                        }
                        let index = this.diffTemplateGame.findIndex((diff) => {return diff.gameId == games[i].id})
                        if(index >= 0){                        
                          this.diffTemplateGame[index].changes.push(data)
                        }else{
                          this.diffTemplateGame.push({
                            gameName: games[i].name,
                            gameId: games[i].id,
                            changes:[data]
                          })
                        }
                      }
                    }
                  }
                }
              });
            }
          });
        }
      });
    }
  }
  applyChange(templateMission, gameMission, param, i, j){
    if(templateMission[param].length>0){ 
      let mission = this._missions[gameMission.gameId].find(mission => mission.id == gameMission.missionId)
      this.missionService.updateMission(mission, { [param]: templateMission[param] }).then(value => {
        this.changeShowToast(value, param)
        this.spliceChange(i, j)
      }, err => {
        this.changeShowToast('error', param)
      });
    } else if(gameMission[param].length>0) {
      let mission = this.templateMissions.find(mission => mission.id == templateMission.missionId)
      this.missionService.updateMission(mission, { [param]: gameMission[param] }).then(value => {
        this.changeShowToast(value, param)
        this.spliceChange(i, j)
      }, err => {
        this.changeShowToast('error', param)
      });
    }
  }

  changeShowToast(type, param){
    if(type == 'error') this.showToast('Error', 'danger', `update ${param} failed`, 'close-outline')
    else this.showToast('Success', 'success', `${param} successfully updateted on game`, 'done-all-outline')
  }

  showToast(type,status ,text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type , text, { position, status, duration,icon });
  }

  spliceChange(i, j){
    if(this.diffTemplateGame[i].changes.length>1) this.diffTemplateGame[i].changes.splice(j, 1)
    else this.diffTemplateGame.splice(i, 1)
  }
  getGameMissionName(gameId, missionId){
    let mission = this._missions[gameId].find(mission => mission.id == missionId)
    if(mission) return mission.name
    else return;
  }

  getTemplateMissionName(templateId, missionId){
    let mission =  this.templateMissions.find(mission => mission.id == missionId)
    if(mission) return mission.name
    else return;
  }

  getGameObject(gameId, objectId){
    let findedObject = this.gameObjects[gameId].find(object => object.id == objectId)
    if(findedObject) return findedObject.labels
    else return;
  }

  getTemplateObject(templateId, objectId){
    let findedObject = this.templateObjects.find(object => object.id == objectId)
    if(findedObject){
      return findedObject.labels
    } else return;
  }

  toggleShowDetailGame(index) {
    this.gameVisibly[index] = this.gameVisibly[index]? !this.gameVisibly[index] : true;
  }

  getDiffOnForkSelections(gameRefs, templateRef, params){
    if(templateRef[params].length > 0){
      for(let TemplateActivateMission of templateRef[params]){        
        if(gameRefs.length>0 ){
          let paramActivateMission = ''
          for(let gameRef of gameRefs){
            if(gameRef[params].length>0){
              let result = gameRef[params].find(templateMission => templateMission == TemplateActivateMission)
              if( result && result != undefined ) paramActivateMission = result;
            }
          }
          if(paramActivateMission.length==0){
            return false
          } 
        }
      }
    }
    return true
  }

  getDifference(gameRefs, templateRef, fork){
    if(templateRef.length>0){
      if(fork == 'dependencies'){
        let paramDependencies = false 
        for (const depTemplate in templateRef) {
          for (const depGame in gameRefs) {
            if(depTemplate === depGame) paramDependencies = true
          } 
        }
        return paramDependencies
      } else{
        for(let reference of templateRef){
          let ref = gameRefs.find(gameRef => gameRef === reference)
          if(ref){ 
            return true
          } else return false
        }
      }
    }else{
      if(gameRefs.length>0) return false
      else return true
    }
  }

  cancel() {
    this.ref.close();
  }
}
